// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"11842839","387":"acf239af","398":"96cf6659","417":"13ff507a","441":"ea419b14","453":"32744d0b","501":"914dfebe","563":"f6f121e8","679":"7587e2c9","756":"fc3db7a3"}[chunkId] + ".chunk.js";
};